<template>
  <hel-module title="近 6 个月采购额趋势" :class="scope.clsPrefix" v-loading="loading">
    <div class="chart-container">
      <div id="purchaseTrendChart" class="chart-body"></div>
      <div class="chart-subtitle">
        {{ startMonth }} ~ {{ endMonth }} · 单位：万元
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import * as echarts from 'echarts'
import { getProcurementTrend } from '@/api/procurement'

export default {
  name: 'PurchaseTrend',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-purchase-trend'
      },
      months: [],
      startMonth: '--',
      endMonth: '--',
      amounts: [],
      chartInstance: null
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getProcurementTrend()
        if (!res || res.code !== 200 || !Array.isArray(res.data) || !res.data.length) {
          this.months = []
          this.amounts = []
          this.startMonth = '--'
          this.endMonth = '--'
          return
        }
        const data = res.data
        this.months = data.map((i) => {
          // '2026-05' → '5月'
          const parts = i.statMonth ? i.statMonth.split('-') : []
          return parts.length === 2 ? String(Number(parts[1])) + '月' : i.statMonth
        })
        this.startMonth = data[0].statMonth
        this.endMonth = data[data.length - 1].statMonth
        this.amounts = data.map((i) => Number(i.amount) || 0)

        this.$nextTick(() => {
          this.drawChart()
        })
      } catch (error) {
        console.error('获取近6个月采购额趋势数据失败:', error)
        this.months = []
        this.amounts = []
        this.startMonth = '--'
        this.endMonth = '--'
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(
        document.getElementById('purchaseTrendChart')
      )
      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            const p = params[0]
            return `${p.axisValue}<br/>${p.marker}采购额: ${p.value}万`
          }
        },
        grid: {
          top: 30,
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.months,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '金额（万元）',
          nameTextStyle: {
            color: '#999999',
            fontSize: 12,
            padding: [0, 0, 0, 30]
          },
          min: 0,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              color: '#f0f0f0',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#999999',
            fontSize: 12
          }
        },
        series: [
          {
            name: '采购额',
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              color: '#4A64F4',
              borderRadius: [4, 4, 0, 0]
            },
            data: this.amounts
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.chartInstance && this.chartInstance.resize()
        })
        setTimeout(() => {
          this.chartInstance && this.chartInstance.resize()
        }, 200)
      })
    },
    handleResize() {
      if (this.chartInstance) {
        setTimeout(() => {
          this.chartInstance.resize()
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-purchase-trend";
.#{$class-prefix} {
  .chart-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .chart-subtitle {
    align-self: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    margin-top: 4px;
  }
  .chart-body {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 260px;
  }
}
</style>
